module.exports = __webpack_public_path__ + "media/images/earth-day-00bced8f697346025df6da0e72ab2733.jpg";